module.exports = __webpack_public_path__ + "media/images/wallet/payment2-f0f9ff945d452491fa09adec53ed1297.svg";